<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tìm kiếm">
          <div slot="content">
            <div class="form-group col-md-6 col-sm-6 col-xs-12">
              <label>Mã</label>
              <input type="text" class="form-control" v-model="filterData.key" placeholder="Nhập tên mã..."/>
            </div>
            <div class="form-group col-md-6 col-sm-6 col-xs-12">
              <label>Giá trị</label>
              <input type="text" class="form-control" v-model="filterData.value" placeholder="Nhập giá trị ..."/>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center ">
              <b-button variant="warning" @click="search">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm kiếm
              </b-button>
            </div>
          </div>
        </va-box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Danh sách cấu hình">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <template v-slot:cell(id)="data">
                {{genSeqId(data)}}
              </template>

              <template v-slot:cell(actions)="dataId">
                <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="edit(dataId.item.id)"><i
                  class="fa fa-edit"/></b-button>
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>
    </section>
  </div>

</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import ParamAPI from '../../../api/param'
import Utils from '../../../common/utils'

export default {
  name: 'ParamList',
  components: {
    'va-box': VABox
  },
  data () {
    return {
      filterData: {
        key: '',
        value: '',
        group: ''
      },
      items: [],
      fields: [
        {
          key: 'id',
          label: 'STT'
        },
        {
          key: 'key',
          label: 'Mã'
        },
        {
          key: 'value',
          label: 'Giá trị'
        },
        {
          key: 'description',
          label: 'Mô tả'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 10%',
          class: 'actions-cell'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ]
    }
  },
  mounted () {
    this.filter()
  },
  methods: {
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    filter () {
      if (this.loading) {
        return
      }

      this.loading = true
      ParamAPI.filter(this.filterData, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
    add () {
      this.$router.push('/param/add')
    },
    edit (id) {
      this.$router.push('/param/edit/' + id)
    },
    remove (id, name) {
      if (id) {
        this.$bvModal.msgBoxConfirm('Xóa ' + name + '. Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            ParamAPI.remove(id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/param/ParamList.vue